import React, { createContext, useCallback, useContext, useState } from 'react'

import PropTypes from 'prop-types'

import { v4 as uuid } from 'uuid'
import ToastContainer from '../components/ToastContainer'

export const ToastMessageProps = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired, // 'info' | 'success' | 'error'
  title: PropTypes.string.isRequired,
  description: PropTypes.string
}

const ToastContext = createContext(
  {}
)

function useToast () {
  const context = useContext(ToastContext)

  if (!context) {
    throw new Error('useToast must be used within an ToastProvider')
  }

  return context
}

const ToastProvider = ({ children }) => {
  const [messages, setMessages] = useState([])

  const addToast = useCallback(({ type, title, description }) => {
    const id = uuid()

    const message = {
      id,
      type,
      title,
      description
    }

    setMessages(messages => [...messages, message])
  }, [])

  const removeToast = useCallback((id) => {
    setMessages(messages =>
      messages.filter(message => message.id !== id)
    )
  }, [])

  return (
    <ToastContext.Provider value={{ addToast, removeToast }}>
      { children }
      <ToastContainer messages={messages}/>
    </ToastContext.Provider>
  )
}

ToastProvider.propTypes = {
  children: PropTypes.any
}

export { useToast, ToastProvider }
